import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';

import * as companySiteUserLocationActions from '../actions/company-site-user-location.actions';
import { ActionType, CompanySiteUserLocationActions as Action } from '../actions//company-site-user-location.actions';


export interface State { companyId: null; siteId: null; companyId_siteId?: null; }
export interface StateCompanyUser { companyId: null; }
export interface StateSite { siteId: null; }
export interface StateCompanySiteCategoryProductGroupProduct { companyId: null; siteId: null; categoryId: null; productGroupId: null; productId: null; }
export interface StateUser { user: { uid: any; email: any; }; }
export interface StateRoomNumber { roomNumber: null; }

export const initialStateCompanySite: State = { companyId: null, siteId: null, companyId_siteId: null };
export const initialStateCompany: StateCompanyUser = { companyId: null };
export const initialStateSite: StateSite = { siteId: null };
export const initialStateCompanySiteCategoryProductGroupProduct: StateCompanySiteCategoryProductGroupProduct = { companyId: null, siteId: null, categoryId: null, productGroupId: null, productId: null };
export const initialStateUser: StateUser = { user: { uid: null, email: null } };
export const initialStateRoomNumber: StateRoomNumber = { roomNumber: null };

export function addCompanySiteUserLocationReducer(
  state: State = initialStateCompanySite,
  action: companySiteUserLocationActions.AddCompanySiteUserLocation
): any {
  switch (action.type) {

    case ActionType.ADD_COMPANYSITEUSERLOCATION:
      return {
        ...state,
        companyId: action.companyId,
        siteId: action.siteId,
        companyId_siteId: action.companyId + action.siteId
      };
    default:
      return state;
  }
}

export function addCompanyUserLocationReducer(
  state: StateCompanyUser = initialStateCompany,
  action: companySiteUserLocationActions.AddCompanyUserLocation
): any {
  switch (action.type) {

    case ActionType.ADD_COMPANYUSERLOCATION:
      return {
        ...state,
        companyId: action.companyId,
      };
    default:
      return state;
  }
}

export function addSiteUserLocationReducer(
  state: StateSite = initialStateSite,
  action: companySiteUserLocationActions.AddSiteUserLocation
): any {
  switch (action.type) {

    case ActionType.ADD_SITEUSERLOCATION:
      return {
        ...state,
        siteId: action.siteId,
      };
    default:
      return state;
  }
}

export function addCompanySiteCategoryProductGroupProductReducer(
  state: State = initialStateCompanySiteCategoryProductGroupProduct,
  action: companySiteUserLocationActions.AddCompanySiteCategoryProductGroupProduct
): any {
  switch (action.type) {

    case ActionType.ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT:
      return {
        ...state,
        companyId: action.companyId,
        siteId: action.siteId,
        categoryId: action.categoryId,
        productGroupId: action.productGroupId,
        productId: action.productId
      };
    default:
      return state;
  }
}

export function addSiteUserReducer(
  state: StateUser = initialStateUser,
  action: companySiteUserLocationActions.AddSiteUser
): any {
  switch (action.type) {

    case ActionType.ADD_SITEUSER:
      return {
        ...state,
        user: action.user,
      };
    default:
      return state;
  }
}

export function addSiteUserHotelRoomNumberReducer(
  state: StateRoomNumber = initialStateRoomNumber,
  action: companySiteUserLocationActions.AddSiteUserHotelRoomNumber
): any {
  switch (action.type) {

    case ActionType.ADD_SITEUSERHOTELROOMNUMBER:
      return {
        ...state,
        roomNumber: action.roomNumber,
      };
    default:
      return state;
  }
}
export const getcompanyId = (state: State) => state.companyId;
export const getSiteId = (state: State) => state.siteId;
export const getCategoryId = (state: StateCompanySiteCategoryProductGroupProduct) => state.categoryId;
export const getProductGroupId = (state: StateCompanySiteCategoryProductGroupProduct) => state.productGroupId;
export const getProductId = (state: StateCompanySiteCategoryProductGroupProduct) => state.productId;
export const getUserId = (state: StateUser) => state;
export const getRoomNumber = (state: StateRoomNumber) => state.roomNumber;
export const getCompanyIdSiteId = (state: State) => ({ companyId: state.companyId, siteId: state.siteId });
